import api, { uninterceptedAxios } from './api';

export type AuthenticateRequest = {
  email: string;
  password: boolean;
};

export type AuthenticateResponse = {
  id: string;
  email: string;
  fullName: string;
  jwtToken: string;
  isBlocked: boolean;
  isAdmin: boolean;
  profilePictureUrl: string;
};

export type SignupRequest = {
  email: string;
  password: string;
  confirmPassword: string;
  namePrefix: string;
  title: string;
  fullName: string;
  phoneNumber: string;
  companyName: string;
  companyWebsite: string;
  companyPhoneNumber: string;
  taxId: string;
  vatId: string;
  address: string;
};

export type PasswordResetEmailRequestModel = {
  email: string;
};

export type PasswordResetModel = {
  newPassword: string;
  email: string;
  token: string;
};

async function login(data: AuthenticateRequest) {
  return uninterceptedAxios.post<AuthenticateResponse>('auth/login', data, { withCredentials: true }).then((res) => {
    localStorage.setItem('token', JSON.stringify(res.data));
    return res;
  });
}

async function signUp(data: FormData) {
  return uninterceptedAxios.post<AuthenticateResponse>('auth/signup-vendor', data, { withCredentials: true }).then((res) => {
    localStorage.setItem('token', JSON.stringify(res.data));
    return res;
  });
}

async function logout() {
  try {
    await api.post<AuthenticateResponse>('auth/logout');
    localStorage.removeItem('token');
  } catch (error) {
    return Promise.reject('Cannot logout');
  }
}

async function requestPasswordResetEmail(data: PasswordResetEmailRequestModel) {
  return uninterceptedAxios.post('auth/request-password-reset-email', data);
}

async function resetPasswordWithToken(data: PasswordResetModel) {
  return uninterceptedAxios.post('auth/reset-password', data);
}

export const AuthService = {
  login,
  signUp,
  logout,
  requestPasswordResetEmail,
  resetPasswordWithToken,
};
